import styled from 'styled-components';
import colors from 'shared-assets/lib/colors';

const Label = styled.label`
  color: ${colors.textColorPrimary};
  font-size: 1rem;
  line-height: 1.5rem;
  cursor: pointer;

  & ~ input ~ label {
    margin-left: 6px;
  }
`;

export default Label;
